export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-4">
            <img src="/images/logos/logo-beyaz.svg" alt="FINORA" className="h-8 mb-4 opacity-80" />
            <p className="font-sub text-[9px] text-white/30 tracking-[0.3em] font-bold mb-4">
              KONUT &bull; YAŞAM &bull; SAHİL
            </p>
            <div className="w-10 h-[2px] bg-[#c13a05] mb-4" />
            <p className="font-body text-sm text-white/35 font-light leading-relaxed max-w-xs">
              Akdeniz'in zamansız kıyısında, doğru yerde ve doğru zamanda kurulan bir yaşam.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="font-sub text-[10px] text-[#c13a05] tracking-[0.2em] font-bold mb-6">PROJE ORTAKLARI</p>
            <div className="space-y-3">
              <div>
                <p className="font-sub text-[9px] text-white/35 tracking-[0.15em] font-bold">PROJE SAHİBİ</p>
                <p className="font-heading text-lg text-white/70 font-normal">Sirius Port</p>
              </div>
              <div>
                <p className="font-sub text-[9px] text-white/35 tracking-[0.15em] font-bold">PAZARLAMA</p>
                <p className="font-heading text-lg text-white/70 font-normal">Riba Gayrimenkul</p>
              </div>
              <div>
                <p className="font-sub text-[9px] text-white/35 tracking-[0.15em] font-bold">İNŞAAT</p>
                <p className="font-heading text-lg text-white/70 font-normal">Pınarlar Grup</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="font-sub text-[10px] text-[#c13a05] tracking-[0.2em] font-bold mb-6">İLETİŞİM</p>
            <p className="font-sub text-2xl text-white font-bold tracking-wide mb-2">444 4 919</p>
            <p className="font-body text-sm text-white/35 font-light">Finike, Antalya</p>
            <div className="flex items-center gap-3 mt-6">
              <div className="w-3 h-3 rounded-full bg-[#c13a05]" />
              <div className="w-3 h-3 rounded-full bg-[#d5bd9a]" />
              <div className="w-3 h-3 rounded-full bg-[#7d7441]" />
              <div className="w-3 h-3 rounded-full bg-[#9ac2cc]" />
            </div>
          </div>
        </div>

        <div className="border-t border-white/8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/25 font-light">
            &copy; 2025 FINORA. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-3">
            <img src="/images/brandmarks/brandmark-beyaz.svg" alt="" className="w-5 opacity-20" />
            <p className="font-sub text-[10px] text-white/15 font-bold tracking-[0.15em]">
              HAYATIN TAM ZAMANI
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
